import { render, staticRenderFns } from "./CollaboratorRoleDetail.vue?vue&type=template&id=5e8f5708&scoped=true&"
import script from "./CollaboratorRoleDetail.vue?vue&type=script&lang=js&"
export * from "./CollaboratorRoleDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorRoleDetail.vue?vue&type=style&index=0&id=5e8f5708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f5708",
  null
  
)

export default component.exports